import { useQuery, UseQueryResult } from 'react-query';
import { SalesPortalAthleteRetrieve } from 'types';
import { client } from 'utils/api-client';

function useSalesPortalAthleteByProfile(
  gymId: string | undefined,
  profileId: string | undefined,
): UseQueryResult<{ data: SalesPortalAthleteRetrieve }> {
  return useQuery(
    ['salesPortalAthleteByProfile', gymId, profileId],
    () => client.get(`sales-portal/gyms/${gymId}/athletes/${profileId}/`),
    {
      enabled: !!gymId && !!profileId,
    },
  );
}

export default useSalesPortalAthleteByProfile;
